import { useSelector, TypedUseSelectorHook } from 'react-redux';
import { RootState } from './store';

/**
 * This is shorthand for useSelector<RootState>(...);
 * Use this instead of useSelector() to get automatic type inference.
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
